<template>
<div id="page-profile" class="container-fluid">
    <div class="row">
        <div class="col-xs-12 head other" v-if="!isOwner">
            <div v-if="user">
                <div class="profile">
                    <div :data-img="getImage" :class="'lazzyLoad'"></div>
                </div>

                <p class="title">{{ user.name }}</p>
                <p class="info">{{ user.type }} <small>/ {{ getCountry.name }}</small></p>

                <p class="actions text-right">
                    <span class="button button-center text-muted" v-show="!isFollowed" @click="toggleFollow">
                        <i class="iconify not-followed" data-icon="fe:star-o" data-height="28"></i>
                    </span>
                    <span class="button button-center" v-show="isFollowed" @click="toggleFollow">
                        <i class="iconify followed" data-icon="fe:star" data-height="28"></i>
                    </span>

                    <span class="button button-center text-muted" v-show="!isBlocked" @click="toggleBlock">
                        <i class="iconify not-blocked" data-icon="bx:bx-circle" data-height="28"></i>
                    </span>
                    <span class="button button-center" v-show="isBlocked" @click="toggleBlock">
                        <i class="iconify blocked" data-icon="bx:bxs-x-circle" data-height="28"></i>
                    </span>
                </p>
            </div>
        </div>

        <div class="col-xs-12 head other" v-if="isOwner">
            <div v-if="user">
                <div class="profile">
                    <div :data-img="getImage" :class="'lazzyLoad'"></div>
                </div>

                <p class="title">My stuff.</p>
                <p class="info">{{ user.name }}</small></p>
            </div>

            <p class="title" v-if="isOwner">
                <small class="pull-right m-t-4 text-disabled font-w-700" @click="logout">
                    LOGOUT
                </small>
            </p> 
        </div>

        <div class="col-xs-12">
            <ul class="page-tabs text-left">
                <li class="active" v-if="playlist.id">Statistics: <router-link :to="'/playlist/'+ playlist.id" tag="span" class="text-danger">{{ playlist.name }}</router-link></li>
                <li :class="{'active' : maintab.active == '#statistics'}" v-if="user.id" @click="changeTab('#statistics', 'maintab')">Statistics</li>
                <li :class="{'active' : maintab.active == '#artwork'}" v-if="user.id" @click="changeTab('#artwork', 'maintab')">EPK</li>
            </ul>
        </div>

        <div class="col-xs-12 tab-content no-padding" style="min-height: 400px;">
            <statistics-playlist :playlist="playlist" v-if="playlist.id"></statistics-playlist>
            <statistics-user :user="user" v-if="user.id && isTabRendered('#statistics', 'maintab')" v-show="isTab('#statistics', 'maintab')"></statistics-user>
            <artwork-user :user="user" v-if="user.id && isTabRendered('#artwork', 'maintab')" v-show="isTab('#artwork', 'maintab')"></artwork-user>
        </div>

        <div class="col-xs-12 footer">
            <div class="row">
                <div class="col-sm-12 clearfix">
                    <ul class="page-tabs lightgreen" :class="{ 'c3': isOwner, 'c2': !isOwner }">
                        <li @click="changeTab('#songs', 'tab', true)" :class="{'active' : isTab('#songs')}">{{ isOwner ? 'My Songs' : 'Uploaded Songs' }}</li>
                        <li @click="changeTab('#playlists', 'tab', true)" :class="{'active' : isTab('#playlists')}" v-if="isOwner">My Lists</li>
                    </ul>
                </div>

                <div class="col-sm-12 tab-content">
                    <tab-songs v-if="isTabRendered('#songs')" v-show="isTab('#songs')" filter="UploadedBy" :header="'search'" :request-data="{ 'uploader_id': user.id }" playlist-name="Uploaded Songs" :tabid="'tab-songs'" :loader="'ripple-light'" :origin="origin"></tab-songs>
                    <tab-playlists v-if="isTabRendered('#playlists')" v-show="isTab('#playlists')" :tabid="'tab-playlists'"></tab-playlists>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</div>
</template>

<script>
export default {
    components: {
        'statistics-user': require('@/components/Profile/Statistics.vue').default,
        'artwork-user': require('@/components/Profile/Artwork.vue').default,
        'statistics-playlist': require('@/components/Playlists/PlaylistTabStatistics.vue').default,
        'tab-songs': require('@/components/Song/List.vue').default,
        'tab-playlists': require('@/components/Profile/Tab/Playlists.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    props:{
        uid: { default: false }
    },

    data() {
        return {
            origin: `${ !this.uid ? "mystuff" : "profile" }.${ this.isOwner ? "My Stuff" : "Profile"} / Songs List`,
            user: false,
            pick: null,
            playlistId: 0,
            playlist: {
                id: 0,
                name: null,
                user: { name: null },
                songs: {}
            },

            maintab: {
                active:'#statistics',
                rendered: {
                    '#statistics': false,
                    '#artwork': false,
                }
            },

            tab: {
                active:'#songs',
                rendered: {
                    '#songs': false,
                    '#playlists': false,
                }
            }
        }
    },  

    mounted() {
        this.playlistId = 1 * localStorage.getItem("default-playlist-"+ App.user.id);

        if (App.allowGtag) gtag('config', 'UA-152097964-2', {
            'page_path' : this.isOwner ? "/mystuff" : "/profile",
            'page_location': this.isOwner ? "/mystuff" : "/profile",
            'page_title' : this.isOwner ? "My stuff" : "Profile",
        });

        this.tab.rendered[this.tab.active] = true;
        this.changeTab('#songs');

        this.maintab.rendered[this.maintab.active] = true;
        this.changeTab('#statistics', 'maintab');


        if (this.playlistId && this.isOwner){
            this.$http.get(this.getPlaylistEndpoint).then((success) => {
                this.playlist = success.data.data;

                if (App.allowGtag) gtag('event', 'open_playlist', {
                    'event_category' : 'playlist',
                    'event_label' : `Open ${ this.playlist.user.id == App.user.id ? 'own' : 'other' } playlist`
                });                    
            });
        }

        this.uid = this.uid ? this.uid : App.user.id;

        if (this.uid){
            if (App.queryParams){
                this.user = App.queryParams;
                App.queryParams = false;
            }else{
                this.$http.get(this.getUserEndpoint).then((success) => {
                    this.user = success.data.data;
                    this.getPick();
                });
            }
        }else{
            this.user = App.user;            
        }
    },

    methods: {
        isTab(tab, name = 'tab') {
            return this[name].active == tab;
        },

        isTabRendered(tab, name = 'tab') {
            return this[name].rendered[tab];
        },

        changeTab(tab, name = 'tab', scroll = false) {
            this[name].active = tab;
            this[name].rendered[tab] = true;
            this.$nextTick(() => {
                if (scroll) $('main').animate({scrollTop: $('main')[0].scrollHeight }, 500);
            });

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : (this.isOwner ? "/mystuff/" : "/profile/") + tab.slice(1),
                'page_location': (this.isOwner ? "/mystuff/" : "/profile/") + tab,
                'page_title' : (this.isOwner ? "My stuff > My " : "Profile > ") + tab.charAt(1).toUpperCase() + tab.slice(2),
            });              
        },

        toggleFollow() {
            var pick = 'follow';
            if (this.pick === 'followed') {
                pick = 'unfollow';
            }
            this.updatePick(pick);
        },

        toggleBlock() {
            var pick = 'block';
            if (this.pick === 'blocked') {
                pick = 'unblock';
            }
            this.updatePick(pick);
        },        

        getPick() {
            this.$http.get(this.getPickEndpoint).then((success) => {
                this.pick = success.data.data.status;
            });
        },

        updatePick(pick) {
            this.$http.post(this.updatePickEndpoint, { pick: pick }).then((success) => {
                this.pick = success.data.data.status;
                this.$root.$emit('pickUpdated', this.pick, this.uid);
            });
        },

        logout() {
            this.$router.push('/login');
        }
    },

    computed: {
        getUserEndpoint() {
            return App.restApi + '/api/user/' + this.uid;
        },

        getPlaylistEndpoint() {
            return App.restApi + '/api/v2/playlists/' + this.playlistId;
        },        

        getPickEndpoint() {
            return App.restApi + '/api/user/' + this.uid + '/picks/status';
        },

        updatePickEndpoint() {
            return App.restApi + '/api/user/' + this.uid + '/picks';
        },

        getCountry(){
            if (this.user.country_id){
                var country = $.grep(App.filters.raw.countries, (c) => { return c.id == this.user.country_id });
                return country[0] ? country[0] : {name: "Unknown"};
            }else{
                return {name: "Country"}
            }
        },

        getImage() {
            this.$nextTick(() => {
                LazzyLoad();
            });
            
            return this.user.profile_image_direct_url ? this.user.profile_image_direct_url : '/img/web/default-avatar.svg';
        },

        isFollowed() {
            return this.pick === 'followed';
        },

        isBlocked() {
            return this.pick === 'blocked';
        },

        isOwner(){
            return this.uid == false || this.uid == App.user.id;
        }
    }
}
</script>